import { InjectionToken } from "@angular/core";
import { SquidexClient } from "@squidex/squidex";

export const SQUIDEX_CLIENT = new InjectionToken<SquidexClient>("SquidexClient");
